var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('public-page',[_c('div',{staticClass:"about"},[_c('about-card'),_c('testimonials-card'),_c('credentials-card'),_c('continuing-education-card'),_c('contact-card')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }